const baseURL = process.env.VUE_APP_BASE_API || 'https://nadc.china-vo.org/galaxycircus';
const oauthAppId = 'nhjG5SWNJ1xiFuxTjK5LWWj1';

export function clearAuthStorage() {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem('Token-Circus');
  window.localStorage.removeItem('umtId');
}

export function getOAuthLoginUrl() {
  const normalizedBaseURL = baseURL.replace(/\/+$/, '');
  const redirectUri = encodeURIComponent(`${normalizedBaseURL}/api/callback`);
  return `https://oauth.china-vo.org/user/login?appid=${oauthAppId}&redirect_uri=${redirectUri}`;
}

export function redirectToLogin() {
  if (typeof window === 'undefined') {
    return;
  }

  if (window.__GALAXY_CIRCUS_AUTH_REDIRECTING__) {
    return;
  }

  window.__GALAXY_CIRCUS_AUTH_REDIRECTING__ = true;
  clearAuthStorage();
  window.location.replace(getOAuthLoginUrl());
}
